<template>
  <div class="nav-main">
    <span class="title">栏目导航</span>
    <ul class="fl">
      <li :class="[{'active': now === 1} ,'fl-content']" @click="flChoose(1)" >
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===1">
        侨联概况
        <span v-if="flDetails.overview <= 99">{{flDetails.overview}}</span>
        <span v-else>99+</span>
      </li>
      <li :class="[{'active': now === 2} ,'fl-content']" @click="flChoose(2)" >
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===2">
        党的建设
        <span v-if="flDetails.pb <= 99">{{flDetails.pb}}</span>
        <span v-else>99+</span>
      </li>
      <li :class="[{'active': now === 3} ,'fl-content']" @click="flChoose(3)" >
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===3">
        工作动态
        <span v-if="flDetails.wd <= 99">{{flDetails.wd}}</span>
        <span v-else>99+</span>
      </li>
      <li :class="[{'active': now === 4} ,'fl-content']" @click="flChoose(4)" >
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===4">
        为侨服务
        <span v-if="flDetails.sc <= 99">{{flDetails.sc}}</span>
        <span v-else>99+</span>
      </li>
      <li :class="[{'active': now === 5} ,'fl-content']" @click="flChoose(5)" >
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===5">
        品牌活动
        <span v-if="flDetails.ba <= 99">{{flDetails.ba}}</span>
        <span v-else>99+</span>
      </li>
<!--      <li :class="[{'active': now === 6} ,'fl-content']" @click="flChoose(6)" v-if="flDetails[5]">-->
<!--        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===6">-->
<!--        {{flDetails[5].title}}-->
<!--        <span v-if="flDetails[5].num <= 99">{{flDetails[5].num}}</span>-->
<!--        <span v-else>99+</span>-->
<!--      </li>-->
    </ul>
  </div>
</template>

<script>
  export default {
    name: "ColumnNav",
    data() {
      return {
        now: this.nowColumn
      }
    },
    props: {
      flDetails: Object,
      nowColumn: Number
    },
    methods: {
      flChoose(num) {
        this.now = num
        this.$emit('b-content',num)
      },
      resetNav() {
        this.now = 1
      }
    },
    watch: {
      '$route':'resetNav'
    }
  }
</script>

<style scoped lang="scss">
  .nav-main {
    width: 180px;
    height: 304px;
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    border: solid 1px #d9d9d9;
    border-top: solid 2px #d43e42;
    .title {
      width: 180px;
      height: 40px;
      text-indent: 20px;
      font-family: 'SourceHanSerifCN-Bold';
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 41px;
      letter-spacing: 0;
      color: #d43e42;
      border-bottom: solid 1px #d9d9d9;
    }
    .fl {
      width: 138px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 0 auto;
      .fl-content {
        cursor: pointer;
        width: 138px;
        font-family: 'SourceHanSansCN-Regular';
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        height: 36px;
        line-height: 36px;
        letter-spacing: 0;
        color: #464646;
        display: flex;
        align-items: center;
        border-bottom: solid 1px #d9d9d9;
        span {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0;
          color: #929292;
          margin-left: auto;
        }
      }
      .fl-content:hover {
        color: #d43e42;
      }
      .active {
        color: #d43e42;
      }
      img {
        width: 6px;
        height: 7px;
        margin-right: 5px;
      }
    }
  }
</style>
